import Splide from '@splidejs/splide';

function mountDescriptionSlider(el) {
  new Splide(el, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    speed: 600,
    rewind: true,
    arrows: true,
    pagination: false,
  }).mount();
}

export const initDescriptionSlider = () => {
  const descriptionSlider = document.querySelector(
    '[data-product-bundle-smart-home-control-descriptions]'
  );

  mountDescriptionSlider(descriptionSlider);
};
